<template>
  <b-modal
    id="addSingleOffer-modal"
    size="xxl"
    ref="addSingleOffer_modal"
    title="Utwórz ofertę"
    no-close-on-backdrop
    v-model="visible"
    @hidden="onClose"
    @show="onShow"
  >
    <div
      class="project-title mb-4"
      :style="setProjectsCollors(info.color) + ';padding:0;'"
    >
      <div class="project-paretname" v-if="info.parent_name">
        <router-link :to="'/construction/' + info.parent_id + '/'">{{
          info.parent_name
        }}</router-link>
      </div>
      <div class="project-name">{{ info.name }}</div>
      <div v-if="customer">
        {{ customer.companyname }}
        <i style="font-size: 90%"
          >{{ customer.firstname }} {{ customer.lastname }}</i
        >
      </div>
    </div>

    <ValidationObserver
      ref="singleOfferFormValidation"
      tag="form"
      @submit.prevent="onSubmit"
      id="offerInfo"
    >
      <b-row>
        <b-col class="col-12">
          <b-form-group
            label="Nr oferty:"
            label-for="offer_number"
            class="required mb-2"
          >
            <ValidationProvider
              name="offer_number"
              rules="required"
              v-slot="validationContext"
            >
              <b-form-input
                id="offer_number"
                v-model="form.offerNumber"
                type="text"
                size="lg"
              ></b-form-input>
              <b-form-invalid-feedback :force-show="true"
                >&nbsp;{{
                  validationContext.errors[0]
                }}</b-form-invalid-feedback
              >
            </ValidationProvider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-6 col-12">
          <b-form-group
            label="Ważne od:"
            label-for="startDate"
            class="mb-2"
          >
            <v-date-picker
              id="startDate"
              class="calendar mb-3"
              v-model="form.startDate"
              :masks="{ input: 'YYYY-MM-DD' }"
              :popover="{ visibility: 'click' }"
              :columns="$screens({ default: 1 })"
            ></v-date-picker>
          </b-form-group>
        </b-col>
        <b-col class="col-lg-6 col-12">
          <b-form-group label="Ważne do:" label-for="endDate" class="required mb-2">
            <ValidationProvider
              name="endDate"
              rules="required"
              v-slot="validationContext"
            >
              <v-date-picker
                id="endDate"
                class="calendar mb-3"
                v-model="form.endDate"
                :masks="{ input: 'YYYY-MM-DD' }"
                :popover="{ visibility: 'click' }"
                :columns="$screens({ default: 1 })"
              ></v-date-picker>
              <b-form-invalid-feedback :force-show="true"
              >&nbsp;{{
                validationContext.errors[0]
                }}</b-form-invalid-feedback
              >
            </ValidationProvider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12">
          <b-form-group label="Opis oferty:" label-for="offer_description">
            <b-form-textarea
              id="offer_description"
              v-model="form.description"
              placeholder="Opis oferty..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </ValidationObserver>

    <button class="btn btn-outline-primary" @click="showAddProductsModal">
      <i class="fas fa-plus"></i> Dodaj wiele produktów
    </button>

    <table
      ref="products_table"
      class="table b-table table table-list table-pro b-table-stacked-lg table-singleoffer"
    >
      <b-thead>
        <tr>
          <th style="width:50px">Poz.</th>
          <th>Nazwa</th>
          <th style="width:100px">Ilość</th>
          <th style="width:80px">Jednostka</th>
          <th style="width:120px">Cena netto</th>
          <th style="width:80px">VAT %</th>
          <th style="width:120px">Razem</th>
          <th>Opcje</th>
        </tr>
      </b-thead>

      <template v-if="isBusy">
        <tr>
          <td colspan="8" class="text-center">
            <TableSpiner />
          </td>
        </tr>
      </template>

      <tbody>
        <template v-if="filteredProducts.length === 0 && isBusy === false">
          <tr>
            <td colspan="8" class="text-center">
              <div class="empty">
                <i class="fas fa-box-open empty-state"></i>
                <span class="empty-search">Brak produktów</span>
              </div>
            </td>
          </tr>
        </template>

        <template v-else-if="filteredProducts.length > 0 && isBusy === false" v-for="(itemGroup, index) in filteredProducts">
          <tr :key="'category_' + index">
            <td data-label="Poz.">{{ index + 1 }}</td>
            <td data-label="Kategoria:" colspan="5">
              <b-input type="text" v-model="itemGroup.groupName"></b-input>
            </td>
            <td></td>
            <td data-label="Opcje:" class="text-center">
              <button
                class="btn btn-outline-danger btn-sm"
                @click="deleteCategory(filteredProducts, itemGroup)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
          <tr
            v-for="(item, itemIndex) in itemGroup.groupItmes"
            :key="'item_' + index + '.' + itemIndex"
          >
            <td data-label="Poz.">{{ index + 1 }}.{{ itemIndex + 1 }}</td>
            <td data-label="Nazwa">
              <b-input
                type="text"
                placeholder="Nazwa produktu"
                v-model="item.name"
                class="offer-product"
              ></b-input>
                <b-form-textarea
                rows="3"
                placeholder="Opis produktu/usługi"
                v-model="item.description"
                class="offer-description"
              ></b-form-textarea>
            </td>
            <td data-label="Ilość">
              <b-input
                class="text-center"
                type="number"
                placeholder="0.00"
                v-model="item.quantity"
              ></b-input>
            </td>
            <td data-label="Jednostka">
              <b-input
                class="text-center"
                type="text"
                placeholder="-"
                v-model="item.unit"
              ></b-input>
            </td>
            <td data-label="Cena netto">
              <b-input
                class="text-center"
                type="number"
                placeholder="0.00"
                v-model.number="item.netto_amount"
              ></b-input>
            </td>
            <td data-label="Vat %">
              <b-input
                class="text-center"
                type="text"
                placeholder="0"
                v-model="item.vat_rate"
              ></b-input>
            </td>
            <td data-label="Razem" class="text-right">
              {{
                (
                  (item.netto_amount * (item.vat_rate / 100) +
                    item.netto_amount) *
                  item.quantity
                ).toFixed(2)
              }}
            </td>
            <td data-label="Opcje" class="text-center">
              <button
                class="btn btn-outline-danger btn-sm"
                @click="deleteCategoryRow(item, itemGroup.groupItmes)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
          <tr class="table-offer-addRow" :key="itemGroup.groupId">
            <td></td>
            <td colspan="7">
              <button
                class="btn btn-outline-primary"
                @click="addCategoryRow(itemGroup)"
              >
                <i class="fas fa-plus"></i> Dodaj produkt
              </button>
            </td>
          </tr>
        </template>
        <tr>
          <td class="text-center" colspan="8">
            <button class="btn btn-primary" @click="addCategory">
              <i class="fas fa-plus"></i> Dodaj kategorie
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="summary">
      <p class="mb-1">
        Kwota całkowita netto:
        <b
          >{{ summaryNetto.toFixed(2) }}
          <small>{{ getMainBaseCurrency }}</small></b
        >
      </p>
      <p class="mb-1">
        Vat:
        <b
          >{{ summaryVat.toFixed(2) }}
          <small>{{ getMainBaseCurrency }}</small></b
        >
      </p>
      <p class="mb-0">
        Kwota całkowita brutto:
        <b
          >{{ (summaryNetto + summaryVat).toFixed(2) }}
          <small>{{ getMainBaseCurrency }}</small></b
        >
      </p>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <b-button
        size="md"
        variant="primary"
        type="submit"
        form="offerInfo"
        :disabled="isDisabled"
        >Zapisz</b-button
      >
      <b-button size="md" variant="outline-danger" @click="cancel()"
        >Anuluj</b-button
      >

      <ProductsMultiselectModal :construction="info" @submit="submitProducts" />
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TableSpiner from "@/components/TableSpiner";
import ProductsMultiselectModal from "@/components/products/ProductsMultiselectModal";
import { flatenCategories } from "@/utils/index.js";
import { setProjectsCollors } from "@/services/helpers";

export default {
  name: "ConstructionModalAddSingleOffer",
  components: { TableSpiner, ProductsMultiselectModal },
  props: ["countOffers"],

  computed: {
    ...mapGetters("company", ["getMainBaseCurrency", "mainCompany"]),
    ...mapGetters("construction", ["info", "customer"]),
    ...mapGetters("products", ["root"]),

    summaryNetto() {
      let sumNetto = 0;
      if (this.filteredProducts && this.filteredProducts.length > 0) {
        this.filteredProducts.forEach((el) => {
          if (el.groupItmes && el.groupItmes.length > 0) {
            el.groupItmes.forEach((subEl) => {
              sumNetto += subEl.quantity * subEl.netto_amount;
            });
          }
        });
      }
      return sumNetto;
    },
    summaryVat() {
      let sumVat = 0;
      if (this.filteredProducts && this.filteredProducts.length > 0) {
        this.filteredProducts.forEach((el) => {
          if (el.groupItmes && el.groupItmes.length > 0) {
            el.groupItmes.forEach((subEl) => {
              sumVat +=
                subEl.netto_amount * (subEl.vat_rate / 100) * subEl.quantity;
            });
          }
        });
      }
      return sumVat;
    },
    isEdited() {
      return !!this.editedItem;
    },
    isDisabled() {
      const { length } = this.filteredProducts;
      return !length;
    },
  },
  data() {
    return {
      visible: false,
      isBusy: false,
      editedItem: null,
      form: {
        description: "",
      },
      company: {},
      filteredProducts: [],
    };
  },
  methods: {
    ...mapActions("offers", ["addOffer", "editOffer"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    show(editedItem) {
      this.visible = true;
      this.editedItem = editedItem ? editedItem : null;
      if (editedItem) this.setModalValues();
    },
    setModalValues() {
      this.form = {
        offerNumber: this.editedItem.name,
        startDate:
          this.editedItem.start_date !== null
            ? new Date(this.editedItem.start_date)
            : null,

        endDate: new Date(this.editedItem.end_date),
        description:
          this.editedItem.description !== null
            ? this.editedItem.description
            : null,
      };
    },
    onShow() {
      this.isBusy = true;
      if (this.isEdited) {
        let i = 0;
        this.editedItem.categories.forEach((category) => {
          category.products.forEach((product) => {
            if (product.unit === null || product.unit === "undefined") {
              product.unit = "";
            }
          });
          i++;
          this.filteredProducts.push({
            groupId: i,
            groupName: category.name,
            groupItmes: category.products,
          });
          this.isBusy = false;
        });
      }
      if (!this.isEdited) {
        this.form.offerNumber =
          "A" +
          new Date().getFullYear() +
          "HH-"+
          this.info.id.toString() +"-" +
          (this.countOffers + 1);
          this.isBusy = false;
      }
    },
    addCategory() {
      this.filteredProducts.push({
        groupId: null,
        groupName: "",
        groupItmes: [],
      });
    },
    deleteCategory(categoryList, category) {
      categoryList.splice(categoryList.indexOf(category), 1);
    },
    addCategoryRow(category) {
      category.groupItmes.push({
        id: null,
        name: "",
        quantity: 0.0,
        unit: "",
        netto_amount: 0.0,
        vat_rate: this.mainCompany.vat_rate,
      });
    },
    deleteCategoryRow(row, categoryItems) {
      categoryItems.splice(categoryItems.indexOf(row), 1);
    },
    showAddProductsModal() {
      this.$bvModal.show("take-products-modal");
    },
    flatenCategories() {
      return flatenCategories(this.root, 0);
    },
    createQuery() {
      if (this.form.startDate) {
        this.form.startDate.setDate(this.form.startDate.getDate() + 1);
      }
      this.form.endDate.setDate(this.form.endDate.getDate() + 1);

      let query = {};
      query.name = this.form.offerNumber;
      query.description =
        this.form.description === "" ? undefined : this.form.description;
      query.start_date = this.form.startDate
        ? this.form.startDate.toJSON().slice(0, 10)
        : null;
      query.end_date = this.form.endDate.toJSON().slice(0, 10);

      let categories = [];
      this.filteredProducts.forEach((category) => {
        let newCategory = {};

        newCategory.name = category.groupName;
        newCategory.description = undefined;
        newCategory.items = [];

        categories.push(newCategory);

        category.groupItmes.forEach((product) => {
          let newProduct = {};

          newProduct.name = product.name;
          newProduct.description =
            product.description === "" ? undefined : product.description;
          newProduct.unit = product.unit === "" ? undefined : product.unit;
          newProduct.netto_amount = product.netto_amount;
          newProduct.vat_rate = product.vat_rate;
          newProduct.quantity = parseFloat(product.quantity);

          newCategory.items.push(newProduct);
        });
      });
      query.categories = categories;
      return query;
    },
    submitProducts(form) {
      form.products.forEach((newproduct) => {
        if (newproduct.unit === null || newproduct.unit === "undefined") {
          newproduct.unit = "";
        }
        let newCategory = this.flatenCategories().find(
          ({ value }) => value === newproduct.category_id
        );
        if (this.filteredProducts.length > 0) {
          let findName = this.filteredProducts.find(
            ({ groupName }) => groupName == newCategory.name
          );
          if (findName) {
            var addNewItem = true;
            findName.groupItmes.forEach((item) => {
              if (item.name === newproduct.name) {
                item.quantity = parseFloat(item.quantity) + newproduct.quantity;
                return (addNewItem = false);
              }
            });
            if (addNewItem === true) {
              findName.groupItmes.push(newproduct);
            }
          } else {
            this.filteredProducts.push({
              groupId: null,
              groupName: newCategory.name,
              groupItmes: [newproduct],
            });
          }
        } else {
          this.filteredProducts.push({
            groupId: null,
            groupName: newCategory.name,
            groupItmes: [newproduct],
          });
        }
      });

      this.$bvModal.hide("take-products-modal");
    },

    onClose() {
      this.form = {};
      this.editedItem = null;
      this.filteredProducts = [];
    },
    onSubmit() {
      this.$refs.singleOfferFormValidation.validate().then((success) => {
        if (!success) {
          return;
        }

        let query = this.createQuery();
        if (this.editedItem && this.editedItem.id > 0) {
          this.editOffer({
            query,
            construction_id: this.info.id,
            offer_id: this.editedItem.id,
          }).then(() => {
             this.$bvModal.hide("addSingleOffer-modal");
          })
        } else {
          this.addOffer({
            query,
            construction_id: this.info.id,
          }).then(() => {
             this.$bvModal.hide("addSingleOffer-modal");
          })
        }
      });
    },
    setProjectsCollors,
  },
};
</script>

<style>
.offer-description{
  margin-top: 5px;
}
.modal-xxl {
  max-width: 1200px;
}
.table-singleoffer input,
.table-singleoffer textarea {
  font-size: 85%;
}
.summary {
  text-align: right;
}
@media (max-width: 991.98px) {
  .table tbody > tr > [data-label]::before {
    width: 100% !important;
    text-align: left !important;
    margin-bottom: 5px !important;
  }
  .table tbody > tr > [data-label="Poz."]::before,
  .table tbody > tr > [data-label="Razem"]::before {
    width: fit-content !important;
    width: -moz-fit-content !important;
  }
  .table tbody > tr > .text-right {
    text-align: left !important;
  }
}
</style>
